module.exports = "<button [attr.aria-current]=\"this.model.selected\" [attr.aria-selected]=\"this.model.selected\" role=\"group\" aria-labelledby=\"select_cat_label\" [ngClass]=\"this.class\" (click)=\"this.clicked($event)\">{{this.model.name}}</button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/product-category/components/category/category.component.html
// module id = ./src/app/product-category/components/category/category.component.html
// module chunks = main